import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Toaster } from "@/components/ui/sonner";
import { WhatsAppFab } from "./WhatsAppFab";
import { SeasonClosedModal } from "./SeasonClosedModal";
import { useEmergentBadgeStyle } from "@/hooks/useEmergentBadgeStyle";

export const Layout = () => {
  const location = useLocation();
  useEmergentBadgeStyle();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
      <SeasonClosedModal />
      <Toaster
        position="bottom-left"
        toastOptions={{
          classNames: {
            toast:
              "rounded-none border border-border bg-white text-foreground shadow-lg font-sans",
            description: "text-foreground/70",
          },
        }}
      />
    </div>
  );
};
